import { render, staticRenderFns } from "./CardSpinner.vue?vue&type=template&id=225ff48d&scoped=true&"
import script from "./CardSpinner.vue?vue&type=script&lang=js&"
export * from "./CardSpinner.vue?vue&type=script&lang=js&"
import style0 from "./CardSpinner.vue?vue&type=style&index=0&id=225ff48d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ff48d",
  null
  
)

export default component.exports